import { render, staticRenderFns } from "./follow-record-export.vue?vue&type=template&id=3d08371d&scoped=true"
import script from "./follow-record-export.vue?vue&type=script&lang=ts"
export * from "./follow-record-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08371d",
  null
  
)

export default component.exports